const STORAGE_PREFIX = "rpo:ai-agent-work:";
export const AI_AGENT_WORK_STATE_EVENT = "rpo:ai-agent-work-state";

const getKey = (userId) => `${STORAGE_PREFIX}${String(userId || "anon")}`;

export function readAiAgentWorkState(userId) {
  try {
    const raw = localStorage.getItem(getKey(userId));
    const value = raw ? JSON.parse(raw) : null;
    return value && typeof value === "object" ? value : null;
  } catch {
    return null;
  }
}

export function writeAiAgentWorkState(userId, nextState) {
  const value = {
    ...(nextState && typeof nextState === "object" ? nextState : {}),
    updatedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(getKey(userId), JSON.stringify(value));
  } catch {
    // The request itself must still proceed if browser storage is unavailable.
  }

  window.dispatchEvent(
    new CustomEvent(AI_AGENT_WORK_STATE_EVENT, { detail: { userId: String(userId || "anon"), state: value } })
  );
  return value;
}

export function clearAiAgentWorkState(userId) {
  try {
    localStorage.removeItem(getKey(userId));
  } catch {}
  window.dispatchEvent(
    new CustomEvent(AI_AGENT_WORK_STATE_EVENT, { detail: { userId: String(userId || "anon"), state: null } })
  );
}
